import React from 'react'
import BreadcrumbNav from '../breadcrumbNav'
import MyImage from '../myImage'
import CommonContent from '../commonContent/inedex'
import InnerHTML from '../InnerHtml'
import CustomLink from '../customLink'
import IconTimer from "@/assets/images/icon/timer.svg";
import IconOpen from "@/assets/images/icon/eye-open.svg";

import { abbreviateNumber, convertDt24hFormat, dateCheck, getImgURL, getSlugUrl } from '@/shared/utils'
import { VerifyIcon } from '@/shared/Icons'
import { BLUR_DATA_URL_BASE64, DEFAULT_BLOG_READ } from '@/shared/constants'

function Article({ article }: any) {
  function Tag(p: any) {
    return (
      <div key={p?.index}>
        <CustomLink
          href={getSlugUrl('/' + p?.item?.oSeo?.sSlug)}
          prefetch={false}
          target='_blank'
          className={`px-4 py-2 me-3 mb-2 inline-block text-sm font-medium rounded-full border border-c text-ScheduledBG uppercase max-w-full text-center whitespace-nowrap align-baseline bg-transparent ${p?.item?.eStatus === 'i' ? 'disabled' : ''
            }`}
        >
          {p?.item?.sName}
        </CustomLink>
      </div>
    )
  }

  return (
    <main className=''>
      <section className=''>
        <div
          className={`flex flex-col items-start justify-between ${article?.oAdvanceFeature?.bEditorsPick && article?.oAdvanceFeature?.bExclusiveArticle && 'flex-col '
            }`}
        >
          <BreadcrumbNav customTitle={article?.sTitle} />
          {/* <article className="article-details-page"> */}
          <article className='w-full'>
            <h1 className={`mt-6 border-b border-b-tabBorder pb-4 mb-0 md:pb-6 text-base md:text-2xl text-textOffWhite`}>{article?.sTitle}</h1>
            <div className={`flex flex-wrap items-center pt-4 pb-6 md:pt-2.5 md:pb-12`}>
              <div className={`font-medium text-ScheduledBG text-base flex items-center capitalize mb-1 md:mb-0 w-full md:w-fit`}>
                <span className='flex items-center'>
                  {article?.oDisplayAuthor?.sDisplayName}
                  {article?.oDisplayAuthor?.bIsVerified && (
                    <span className={`inline-block rounded-full ms-1`}>
                      <VerifyIcon />
                    </span>
                  )}
                </span>
              </div>
              <span className='hidden md:block h-1.5 w-1.5 rounded-full bg-t-700 mx-2'></span>
              <div className='flex items-center text-t-700'>
                <p className={`flex items-center gap-2 mb-0 capitalize text-sm md:text-base`}>
                  <MyImage
                    src={IconOpen}
                    width={24}
                    height={24}
                    alt="eye"
                  />
                  {abbreviateNumber(article?.nViewCount)} Views
                </p>
                <span className='h-1.5 w-1.5 rounded-full bg-t-700 mx-2'></span>
                <p className={`flex items-center gap-1 mb-0 text-sm md:text-base`}>
                  <MyImage
                    src={IconTimer}
                    width={24}
                    height={24}
                    alt="timer"
                  />
                  <span>{article?.nDuration > 0 ? article?.nDuration : DEFAULT_BLOG_READ} min read</span>
                </p>
              </div>
              <p className={`text-xs w-full font-medium mt-2 mb-0 text-t-700`}>
                {(article?.dPublishDisplayDate || article?.dPublishDate) && (
                  <>
                    <time
                      className='op-published'
                      dateTime={dateCheck(article?.dPublishDisplayDate || article?.dPublishDate)?.toISOString()}
                    >
                      Published - {convertDt24hFormat(dateCheck(article?.dPublishDisplayDate || article?.dPublishDate))}
                    </time>
                  </>
                )}
              </p>
            </div>

            <figure>
              <div
                className={`w-full pb-4 md:pb-6 border-tabBorder md:border-b md:mb-4 rounded-lg after:[content:''] after:bottom-0 md:after:h-80 after:h-40 after:w-full after:z-10 relative overflow-hidden`}
              >
                <MyImage
                  src={getImgURL(article?.oImg?.sUrl)}
                  alt={article?.oImg?.sText || article?.sSrtTitle}
                  placeholder='blur'
                  blurDataURL={BLUR_DATA_URL_BASE64}
                  className='object-cover w-full aspect-[16/10] rounded-xl md:rounded-3xl'
                  height={520}
                  width={936}
                  sizes='(max-width: 767px) 320px, (max-width: 991px) 360px, (max-width: 1190px) 400px, 600px'
                />
              </div>
            </figure>
            {/* article content */}
            <CommonContent>
              <InnerHTML html={article?.sContent} />
            </CommonContent>
            <div className={`flex lg:flex-wrap pb-2 lg:pb-0 scroll-list`}>
              {article?.aSeries?.map((item: any, index: number) => (
                <Tag key={item?._id} item={item} index={index} />
              ))}
              {article?.aTeam?.map((item: any, index: number) => (
                <Tag key={item?._id} item={item} index={index} />
              ))}
              {article?.aPlayer?.map((item: any, index: number) => (
                <Tag key={item?._id} item={item} index={index} />
              ))}
              {article?.aTags?.map((item: any, index: number) => (
                <Tag key={item?._id} item={item} index={index} />
              ))}
            </div>
          </article>
        </div>
      </section>
    </main>
  )
}

export default Article
